import { ComponentProps } from 'react';
import { ExpandableMenuItem as OriginalExpandableMenuItem } from '@cld/navigation-menu';
import { Typography } from '@clds/typography';

export type ExpandableMenuItemProps = ComponentProps<typeof OriginalExpandableMenuItem>;

export const ExpandableMenuItem = ({ label, ...rest }: ExpandableMenuItemProps) => (
  <OriginalExpandableMenuItem
    verticalPadding="none"
    label={
      <Typography size="sm" type="highContrast">
        {label}
      </Typography>
    }
    {...rest}
  />
);
